module.exports = __webpack_public_path__ + "fonts/TelefonicaIconsTracking.6bc55c95.woff";